import React from 'react';
import ConsultationBookedWithField from '../ConsultationBookedWithField';

const ConsultationBookedWithCell = ({ openAppointmentAssignTaskFuc }) => ({
    field: 'consultation_booked_with',
    headerName: 'Consultation booked with',
    width: 130,
    minWidth: 100,
    sortable: false,
    renderCell: (params) => (
        <ConsultationBookedWithField rowData={params.row} OpenAssignTask={openAppointmentAssignTaskFuc} />
    ),
});

export default ConsultationBookedWithCell;
